import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <section id="contact" className="py-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="space-y-8"
        >
          <h2 className="text-4xl md:text-5xl font-serif text-slate-100 mb-6">
            Begin the Conversation
          </h2>
          <div className="w-16 h-px bg-amber-400 mx-auto mb-8" />
          
          <p className="text-xl text-slate-300 leading-relaxed max-w-2xl mx-auto">Transformative partnerships begin with a single conversation. We engage exclusively with organizations ready to embrace profound change.</p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.3 }}
            className="space-y-6 pt-8"
          >
            <div className="text-slate-400 text-sm tracking-widest uppercase mb-6">
              By Invitation & Referral Only
            </div>
            
            <div className="space-y-4">
              <p className="text-slate-300">
                <span className="text-amber-400">Correspondence:</span>inquiries@oxfordhldg.com</p>
            </div>

            <div className="pt-8 border-t border-slate-700/50">
              <p className="text-slate-400 text-sm">
                Initial consultations are conducted by appointment only. 
                <br />
                Please reference your introduction source when reaching out.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;